import { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { PageLoading } from "../components/ui/PageLoading";
import { useCheckAndAcceptInvitations } from "../components/util/GetUsersVenues/useCheckAndAcceptInvitations";
import { useGetMerchant } from "../components/util/GetUsersVenues/useGetMerchant";
import useGetSelectedVenue from "../components/util/GetUsersVenues/useGetSelectedVenue";
import { useStartupData } from "../components/util/GetUsersVenues/useStartup";
import { useVenueStartup } from "../components/util/GetUsersVenues/useVenueStartup";
import { VENUE_IMPORTER_URL, NEW_MERCHANT, CREATE_USER_MERCHANT, VENUES_OVERVIEW, GROUPS_MANAGEMENT_URL } from "../const/URL.const";
import { parseVenueUrl } from "../utils/redirectUrls";

/**The user is redirected here as part of the startup flow */
export function VenueStartupContainer() {
    const redirectURL = sessionStorage.getItem('redirectURL');
    const { 
        isMerchantLoading, 
        merchant, 
    } = useGetMerchant();

    const { hasInvitations ,  isCheckingInvitations } = useCheckAndAcceptInvitations(merchant , isMerchantLoading);

    const { hasVenues, selectedVenue, isVenueSettingUp} = useGetSelectedVenue(merchant, isMerchantLoading);

    

    const [redirectRoute, setRedirectRoute] = useState<string | null>(null);

    /**Redux app data */
    useStartupData();
    const { isCompleted } = useVenueStartup(selectedVenue);

    useEffect(() => {
        const isVenue = (selectedVenue === null || selectedVenue);
        if (isCompleted && isVenue) {
            setRedirectRoute(parseVenueUrl(redirectURL));
        };
    }, [isCompleted, selectedVenue, redirectURL]);

 
    if (selectedVenue === null) { 
        if(redirectURL?.includes(GROUPS_MANAGEMENT_URL)){
            return <Redirect to={redirectURL} />
        }else{
            return <Redirect to={VENUES_OVERVIEW} />
        } 
    }
    if (redirectRoute) {
        return <Redirect to={redirectRoute} />
    }
    if (( !merchant || Object.keys(merchant).length === 0) && !isMerchantLoading && !isCheckingInvitations) {
        return <Redirect to={CREATE_USER_MERCHANT} />
    }
    if (!isMerchantLoading  && !hasVenues && !isVenueSettingUp && merchant !== null) {
        if (merchant.onboarding_source === "SQUARE") {
            return <Redirect to={VENUE_IMPORTER_URL} />
        }
        if(!hasInvitations && !isCheckingInvitations) {
            return <Redirect to={NEW_MERCHANT} />
        } else if(hasInvitations) {
            return <Redirect to={VENUES_OVERVIEW} />
        }
        
    }
    return <PageLoading />;

}